import './SidePanel.css';

import { Tabs, TutorialPanel } from '@amzn/awsui-components-react';
import { useContext } from 'react';

import { HelpPanelTopicOptions } from '../../common/Constants';
import HelpPanelContent from '../../common/help-panel/HelpPanelContent';
import { constants } from '../../common/Localization';
import GuidedTourContext from '../../contexts/GuidedTourContext';
import { TutorialPanelI18nStrings } from '../tutorials/i18n';

interface Props {
    helpPanelTopic: HelpPanelTopicOptions
}

function SidePanel(props: Props) {

    const context = useContext(GuidedTourContext);

    const helpPanel = HelpPanelContent[props.helpPanelTopic] || HelpPanelContent[HelpPanelTopicOptions.DEFAULT];
    const tours = context.tourStore.getToursByPage(props.helpPanelTopic);

    const tabs = [
        { 
            label: constants.INFO_TAB,
            id: 'info',
            content: helpPanel
        }, 
        {
            label: constants.TUTORIAL_TAB,
            id: 'tours-panel',
            content: <TutorialPanel 
                className={'hiddenLinks'}
                tutorials={tours}
                downloadUrl={window.location.href} // can be anything
                i18nStrings={TutorialPanelI18nStrings}
                onFeedbackClick={() => {}} //this link is never shown, so the event cannot be fired.
            />
        }
    ];

    if(tours.length == 0) {
        return helpPanel;
    } else {
        return <Tabs tabs={tabs} />;
    }
}

export default SidePanel;
